import { WidgetTableDataItem } from 'types/machine-health';
import { ExtractedImageData, UploadTagsImageFn } from './types';
import { ToastMsg } from 'common/components/Toast';

// Recursively extracts image data and strips imageUrl/imageSize from configuration items
export const extractImageData = (
  items: WidgetTableDataItem[]
): { strippedItems: WidgetTableDataItem[]; images: ExtractedImageData[] } => {
  const images: ExtractedImageData[] = [];

  const stripItem = (item: WidgetTableDataItem): WidgetTableDataItem => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { imageUrl, imageSize, ...rest } = item as WidgetTableDataItem & {
      imageUrl?: string;
      imageSize?: number;
    };

    if (imageUrl && imageSize) {
      images.push({
        id: item.id,
        imageUrl: imageUrl,
        imageSize: imageSize
      });
    }

    return {
      ...rest,
      members: item.members ? item.members.map(stripItem) : item.members
    };
  };

  const strippedItems = items.map(stripItem);
  return { strippedItems, images };
};

export const fetchImageAsFile = async (url: string, id: string): Promise<File | null> => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const fileName = url.split('/').pop()?.split('?')[0] || `image-${id}`;
    return new File([blob], decodeURIComponent(fileName), { type: blob.type });
  } catch (error) {
    console.error(`Failed to fetch image for widget ${id}:`, error);
    return null;
  }
};

export const uploadTagImageAPI = async (
  uploadTagsImage: UploadTagsImageFn,
  machineId: string,
  tagId: string,
  tagImageFile: File
) => {
  try {
    await uploadTagsImage({
      machineId,
      widgetId: tagId,
      file: tagImageFile
    }).unwrap();
  } catch (error) {
    console.error('Error tag update image:', error);
  }
};

export const uploadExtractedImages = async (
  uploadTagsImage: UploadTagsImageFn,
  machineId: string,
  images: ExtractedImageData[]
) => {
  try {
    const uploadPromises = images.map(async (imageData) => {
      const file = await fetchImageAsFile(imageData.imageUrl, imageData.id);
      if (file) {
        return uploadTagImageAPI(uploadTagsImage, machineId, imageData.id, file);
      }
    });
    await Promise.all(uploadPromises);
  } catch (error) {
    console.error('Error uploading copied images:', error);
    ToastMsg({ heading: 'Error', type: 'error', message: 'Failed to upload copied images' });
  }
};
